export function setPosts(state, posts) {
  state.posts = posts;
}

export function setPost(state, post) {
  state.selectedPost = post;
}

export function postsError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
  state.posts = [];
}

export function setImportantPosts(state, posts) {
  state.important_posts = posts;
}

export function setComment(state, payload) {
  let comments = [...state.selectedPost.comments, payload]
  state.selectedPost.comments = comments;
}

export function setLiked(state, payload) {
  state.selectedPost.interactions.find(i => i.name === payload.type).total += payload.value
  state.selectedPost.interaction_type = payload.interactionType
  state.selectedPost.interaction_id = payload.interactionId
}
export function setLastMomentSecurity(state, moment) {
  state.lastMomentSecurity = moment;
}
export function setLastPosts(state, posts) {
  state.lastPosts = posts;
}